import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import { useCallback, useEffect, useState } from "react";
import debounce from "lodash/debounce";
import { useHistory, useParams, useLocation } from "react-router-dom";
import {
  getAllManufacturers,
  getProductsByManufacturer,
  TransferProductsFromOneMfgToOther,
} from "../../../api/pagination";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";

const useMfgDetails = () => {
  const history = useHistory();
  const { all_manufacturers } = useSelector((state) => state.redux);
  const { id } = useParams();
  const { state } = useLocation();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [totalItems, setTotalItems] = useState(0);
  const [products, setProducts] = useState([]);
  const [loadingProducts, setLoadingProducts] = useState(false);

  const [selectedManufacturer, setSelectedManufacturer] = useState(null);
  const [searchedMfg, setSearchMfg] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [details, setDetails] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [manufactures, setManufacturers] = useState([]);
  const [modal, setModal] = useState(false);
  const handleLink = () => {
    window.open(details?.loaLos, "_blank");
  };
  const getPartNumber = (product) => {
    const parts = product?.sku
      ? product.sku.split("-").slice(1).join("-")
      : [0];
    return parts;
  };
  const handleTransfer = async () => {
    try {
      if (!details?._id || !selectedManufacturer?._id) {
        toast.error("Please select both manufacturers before transferring.");
        return;
      }
      setIsLoading(true);
      TransferProductsFromOneMfgToOther(
        details?._id,
        selectedManufacturer?._id,
        (response) => {
          setIsLoading(false);

          if (response.status === 200 && response.data?.success) {
            const { message, stats, targetManufacturer } = response.data;
            toast.success(
              `${message}. ${stats.productsUpdated} products moved to ${targetManufacturer?.name}.`
            );
            setModal(false);
            history.push("/admin/manufacturers");
          } else {
            console.error("Transfer failed:", response.message);
            toast.error(response.message || "Transfer failed.");
            history.push("/admin/manufacturers");
          }
        }
      );
    } catch (error) {
      console.error("Error occurred while transferring products:", error);
      toast.error("Something went wrong while transferring products.");
      setIsLoading(false);
      history.push("/admin/manufacturers");
    }
  };


  const fetchManufacturersDebounced = useCallback(
    debounce((searchText) => {
      getAllManufacturers(1, searchText, 50, (res) => {
        if (res) {
          setSearchMfg(res?.data?.data);
        }
        setDataLoading(false);
      });
    }, 500),
    []
  );

  const handleManufacturerSearch = (searchText) => {
    setDataLoading(true);
    fetchManufacturersDebounced(searchText);
  };
  const handleMfg = (val) => {
    let source = searchedMfg?.length > 0 ? searchedMfg : all_manufacturers;
    let res = source?.find((i) => i?._id === val);
    setSelectedManufacturer(res);
    setModal(true);
  };

  const fetchProducts = () => {
    if (details?._id) {
      setLoadingProducts(true);
      getProductsByManufacturer(details?._id, page, pageSize, (res) => {
        if (res?.data) {
          const pagination = res.data.pagination;
          setProducts(res.data.data ?? []);
          setTotalItems(pagination?.totalItems || 0);
          setLoadingProducts(false);
        } else {
          console.log("something is wrong");
          setLoadingProducts(false);
        }
      });
    }
  };

  useEffect(() => {
    fetchProducts();
  }, [details, page, pageSize]);

  useEffect(() => {
    if (all_manufacturers?.length > 0) {
      setManufacturers(all_manufacturers ?? []);
    }
  }, [all_manufacturers]);

  useEffect(() => {
    const unsubscribe = firebase
      .firestore()
      .collection("Manufacturers")
      .doc(id)
      .onSnapshot((doc) => {
        if (doc.exists) {
          const currentData = doc.data();
          setDetails(currentData ?? state);
        }
      });
    return () => unsubscribe();
  }, [id]);


  return {
    details,
    products,
    loadingProducts,
    totalItems,
    page,
    setPage,
    pageSize,
    setPageSize,
    handleManufacturerSearch,
    handleMfg,
    selectedManufacturer,
    setSelectedManufacturer,
    modal,
    setModal,
    handleLink,
    handleTransfer,
    getPartNumber,
    history,
    searchedMfg,
    all_manufacturers,
    dataLoading,
    isLoading,
  };
};

export default useMfgDetails;
